<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getDebits"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-1">Debit</div>
        <div class="col-md-2">Created</div>
  
         <div class="col-md4">Reference</div>
        <div class="col-md-2">Amount</div>
        <div class="col-md-3">Type</div>
      </template>

      <template v-slot:rows="slotProps">
         <div class="col-md-1 my-auto">
          <p class="m-0">{{ slotProps.item.debit_number }}</p>
        </div>

        <div class="col-md-2 my-auto">
          {{
            moment(new Date(slotProps.item.created_at)).format(
              "DD MMM YY"
            )
          }}
        </div>

      

       

        <div class="col-md-4 my-auto">
          <p class="m-0">
              {{slotProps.item.reference}}                
          </p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0  text-monospace">{{ slotProps.item.transaction_amount }}</p>
        </div>


        <div
          class="col-md-3 my-auto pt-3 pt-md-0" v-if="slotProps.item.payment_type"
        >
          {{ slotProps.item.payment_type.type   }}
        </div>
      </template>
    </data-table>

     

  </div>
</template>

<script>
import partnerAccountRepo from "@/api/repos/partnerAccountRepo";
import dataTable from "@/components/common/DataTable";

export default {
  props: ["accountId"],

  components: {
    dataTable,
  },

  data() {
    return {
      debitShow:false,
      selectedDebit:null,
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Latest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getDebits({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getDebits(e) {
      this.isLoad = true;
      try {
        let { data } = await partnerAccountRepo.debits(
          this.accountId,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.debits.data;
        this.totalRows = data.debits.total;
        this.page = data.debits.current_page;
        this.fromRow = data.debits.from;
        this.toRow = data.debits.to;
        this.lastPage = data.debits.last_page;

         


      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
